'use client';

import { useEffect, useRef } from 'react';

export const RELEVANT_ID_SCRIPT_URL = '//d3op16id4dloxg.cloudfront.net/RelevantID4.js';
export const RELEVANT_ID_SCRIPT_ID = 'relevant-id-script';

// Track how many mounted instances require the script
let relevantIdConsumers = 0;

export const RVIDFormElements = [
    'ClientID',
    'SurveyID',
    'PanelistID',
    'GeoCodes',
    'PanelID',
    'RequestCSOData',
    'TimePeriod',
    'MembershipTenure',
    'VID',
    'CustomFactor',
];
interface RVIDFormProps {
    setWasRelevantIdScriptLoaded: (val: boolean) => void;
}

export const RVIDForm = ({ setWasRelevantIdScriptLoaded }: RVIDFormProps) => {
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        relevantIdConsumers += 1;

        const handleReady = () => {
            // Only consider "loaded" when the vendor actually exposed the API
            if (isMountedRef.current && typeof window !== 'undefined' && window.relevantID) {
                setWasRelevantIdScriptLoaded(true);
            }
        };

        let script = document.getElementById(RELEVANT_ID_SCRIPT_ID) as HTMLScriptElement | null;

        if (typeof window !== 'undefined' && window.relevantID) {
            handleReady();
        } else if (script) {
            // Script tag exists but API may not be ready yet — listen for load
            script.addEventListener('load', handleReady);
        } else {
            script = document.createElement('script');
            script.id = RELEVANT_ID_SCRIPT_ID;
            script.src = RELEVANT_ID_SCRIPT_URL;
            script.async = true;
            script.addEventListener('load', handleReady);
            script.addEventListener('error', () => {
                if (isMountedRef.current) setWasRelevantIdScriptLoaded(false);
            });
            document.head.appendChild(script);
        }

        return () => {
            isMountedRef.current = false;

            const existing = document.getElementById(
                RELEVANT_ID_SCRIPT_ID,
            ) as HTMLScriptElement | null;

            if (existing) existing.removeEventListener('load', handleReady);

            relevantIdConsumers -= 1;
            if (relevantIdConsumers === 0) {
                const s = document.getElementById(
                    RELEVANT_ID_SCRIPT_ID,
                ) as HTMLScriptElement | null;

                if (s && s.parentNode) s.parentNode.removeChild(s);

                setWasRelevantIdScriptLoaded(false);
            }
        };
    }, [setWasRelevantIdScriptLoaded]);

    return (
        <form name="RVIDform" style={{ height: 0 }}>
            {RVIDFormElements.map((elName) => (
                <input type="hidden" id={elName} name={elName} key={elName} />
            ))}
        </form>
    );
};
